import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Y si tengo orden de deportación?',
    a: 'Salir voluntariamente es tu derecho. Estos países miran tu capital y tu récord criminal en tu país de origen, no tu pasado civil migratorio en EE.UU.'
  }, {
    q: '¿Cuánto dinero necesito tener ahorrado?',
    a: 'Desde $5,000 en total para solteros (incluyendo vuelos, trámites y demostración de fondos). La matriz de costos te mostrará exactamente qué país se ajusta a tu presupuesto.'
  }, {
    q: '¿Qué pasa con mis hijos nacidos en USA?',
    a: 'Tus hijos mantienen su ciudadanía estadounidense y pueden obtener doble nacionalidad en el país destino. Les estarás regalando un futuro con opciones en Europa o Latinoamérica.'
  }, {
    q: '¿Es legal sacar mi dinero de EE.UU.?',
    a: 'Sí, es 100% legal. El dinero que ganaste trabajando es tuyo. La Guía Bancaria Anti-Bloqueo te enseña cómo transferirlo o llevarlo en efectivo cumpliendo todas las leyes de aduanas.'
  }, {
    q: '¿Necesito contratar a un abogado?',
    a: 'No para empezar. Esta guía te da el mapa exacto para que tú mismo inicies los trámites y sepas exactamente qué pedir si decides contratar ayuda local en el país destino, evitando estafas.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 30 días de garantía completa. Si sientes que la guía no te da un plan claro y accionable para tu residencia legal, pides el reembolso y listo. Sin preguntas.'
  }, {
    q: '¿Qué formato tiene y cómo lo recibo?',
    a: 'Es un producto digital en formato PDF. Recibes acceso inmediato después del pago por correo electrónico. Funciona perfecto en móvil y PC.'
  }, {
    q: '¿Por qué estos 5 países?',
    a: 'Porque tienen leyes migratorias favorables para hispanos, permiten obtener residencia por solvencia económica (sin necesidad de comprar propiedades millonarias) y ofrecen un camino rápido a la ciudadanía.'
  }];
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-265">
      <div className="max-w-[680px] mx-auto" data-id="element-266">
        <h2 className="text-xl md:text-2xl font-serif text-center mb-5 md:mb-8 text-[var(--text-heading)]" data-id="element-267">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-1.5 md:space-y-2" data-id="element-268">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-[var(--bg-card)] rounded-lg border border-[var(--border-subtle)] shadow-sm overflow-hidden" data-id="element-269">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-3 p-3.5 md:p-5 text-left" data-id="element-270">
                <span className="font-serif font-bold text-[var(--text-heading)] text-sm leading-snug" data-id="element-271">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="flex-shrink-0 text-[var(--accent)]" data-id="element-272">
                  <ChevronDown className="w-4 h-4" data-id="element-273" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-274">
                {openIndex === i && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-275">
                    <p className="px-3.5 md:px-5 pb-3.5 md:pb-5 text-[var(--text-muted)] text-xs md:text-sm leading-relaxed border-t border-[var(--border-subtle)] pt-3" data-id="element-276">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}